import { observer } from "mobx-react-lite";

import { FieldItemError, useTheme } from "@bps/fluent-ui";
import { ServiceWarningsHelper } from "@modules/billing/screens/shared-components/add-service-modal/context/ServiceWarningsHelper.ts";
import { InvoiceItemFormValue } from "@modules/billing/screens/shared-components/types/invoice-item-form-value.interface.ts";
import { FormItemField } from "@ui-components/form/FormItemField.tsx";

import { InvoiceItemsColumnNames } from "./InvoiceForm.types.tsx";
import { ServiceSelectField } from "./service-select-field/ServiceSelectField.tsx";

interface InvoiceFormItemListDescriptionProps {
  claimId: string | undefined;
  index: number;
  item: InvoiceItemFormValue;
  serviceWarningsHelper: ServiceWarningsHelper;
}

export const InvoiceFormItemListDescription = observer(
  ({
    claimId,
    index,
    item,
    serviceWarningsHelper
  }: InvoiceFormItemListDescriptionProps) => {
    const theme = useTheme();
    const warnings = serviceWarningsHelper.getServiceWarnings(item, {
      claimId
    });

    const errors = serviceWarningsHelper.getServiceErrors(item, {
      claimId
    });

    return (
      <>
        <ServiceSelectField
          name={`invoiceItems[${index}]`}
          placeholder="Description"
          useDescription
          styles={{ root: { width: "100%" } }}
        />
        <div>
          {errors?.messages?.map(message => (
            <FieldItemError
              name={`${InvoiceItemsColumnNames.description}-error`}
              key={message}
              errorMessage={message}
            />
          ))}
          {!errors?.messages?.length &&
            warnings?.messages?.map(message => (
              <FieldItemError
                name={`${InvoiceItemsColumnNames.description}-warning`}
                key={message}
                errorMessage={message}
                styles={{
                  errorMessage: {
                    color: theme.palette.yellowDark
                  }
                }}
              />
            ))}
        </div>
        <FormItemField name={`invoiceItems[${index}].description`} />
      </>
    );
  }
);
